import { PROMO_CODES_STATUS_LIST } from '../../../constants/statuses';
import { GLOBAL_EXPORT_BUTTON_ENABLED } from '../../../constants/user';

export const INITIAL_FILTERS_STATE = {
  sort_by: 'title',
  order: 'asc',
};

export const PROMO_CODES_PAGE_INFO = {
  title: 'Promo Codes',
};

export const PROMO_CODES_FORM_INITIAL_DATA = {
  // main
  title: '',
  description: '',
  status: PROMO_CODES_STATUS_LIST[1].value,
  // discount
  discount: {
    value: 0,
    kind: 1,
    quantity: 0,
  },
};

export const sortFieldMap = {
  discountValue: 'discount.value',
  discountKind: 'discount.kind',
  discountQuantity: 'discount.quantity',
};

export const EXPORT_BUTTON_ENABLED = [
  ...GLOBAL_EXPORT_BUTTON_ENABLED,
  'mila.staneva@redtrack.io',
  'svyatoslav.svyatsky@redtrack.io',
  'olga@redtrack.io',
];

export const PROMO_CODES_KIND_LIST = [
  {
    value: 1,
    label: 'Percent',
  },
  {
    value: 2,
    label: 'Dollars',
  },
];

export const PROMO_CODES_MAIN_FIELDS = [
  {
    type: 'textField',
    label: 'Title',
    name: 'title',
    placeholder: 'Title',
    required: true,
  },
  {
    type: 'textField',
    label: 'Description',
    name: 'description',
    placeholder: 'Description',
  },
  {
    type: 'select',
    label: 'Status',
    name: 'status',
    placeholder: 'Status',
    options: PROMO_CODES_STATUS_LIST,
    className: 'select',
    required: true,
  },
];

export const PROMO_CODES_DISCOUNT_FIELDS = [
  {
    type: 'textField',
    label: 'Value',
    name: 'discount.value',
    placeholder: 'Value',
    required: true,
  },
  {
    type: 'select',
    label: 'Kind',
    name: 'discount.kind',
    placeholder: 'Kind',
    options: PROMO_CODES_KIND_LIST,
    className: 'select',
    required: true,
  },
  {
    type: 'textField',
    label: 'Quantity',
    name: 'discount.quantity',
    placeholder: 'Quantity',
    required: true,
  },
];
